import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE_URL = "https://vanakkamhrd.com";

const EVENT_NAMES = {
  festival: "TN Annual HR Summit 2026",
  confluence: "India HR Confluence 2026",
};

const isImageFile = (p) => /\.(jpg|jpeg|png)$/i.test(p || "");

const styles = {
  page: {
    minHeight: "100vh",
    background: "#f4f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    fontFamily: "'Poppins', 'Segoe UI', sans-serif",
  },
  card: {
    width: "100%",
    maxWidth: 420,
    background: "#fff",
    borderRadius: 16,
    overflow: "hidden",
    boxShadow: "0 8px 30px rgba(20,24,60,0.12)",
  },
  header: {
    background: "linear-gradient(90deg, #2f0a8c, #14173c)",
    color: "#F28500",
    textAlign: "center",
    padding: "18px 12px",
    fontSize: 24,
    fontWeight: 700,
  },
  body: { padding: "24px 22px", textAlign: "center" },
  photo: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    objectFit: "cover",
    border: "4px solid #F28500",
  },
  initial: {
    width: 120,
    height: 120,
    borderRadius: "50%",
    background: "#dfe3ee",
    color: "#6b7086",
    fontSize: 44,
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "4px solid #F28500",
  },
  name: { fontSize: 22, fontWeight: 700, margin: "14px 0 4px", color: "#1c1f2e" },
  sub: { fontSize: 15, color: "#444", margin: "2px 0" },
  rows: { marginTop: 18, textAlign: "left", borderTop: "1px solid #e6e8ef" },
  row: {
    display: "flex",
    justifyContent: "space-between",
    gap: 12,
    padding: "11px 0",
    borderBottom: "1px solid #e6e8ef",
    fontSize: 14,
  },
  label: { color: "#6b7086" },
  value: { fontWeight: 600, color: "#1c1f2e", textAlign: "right", wordBreak: "break-all" },
  msg: { textAlign: "center", padding: 40, color: "#6b7086" },
};

export default function PassPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [status, setStatus] = useState("loading"); // loading | ok | notfound | error

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/registrations/pass/${token}`);
        if (res.status === 404) {
          if (!cancelled) setStatus("notfound");
          return;
        }
        if (!res.ok) throw new Error("failed");
        const json = await res.json();
        if (!cancelled) {
          setData(json);
          setStatus("ok");
        }
      } catch {
        if (!cancelled) setStatus("error");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.header}>Delegate Pass</div>

        {status === "loading" && <div style={styles.msg}>Loading...</div>}
        {status === "notfound" && <div style={styles.msg}>This pass is not valid.</div>}
        {status === "error" && <div style={styles.msg}>Could not load the pass. Please try again.</div>}

        {status === "ok" && data && (
          <div style={styles.body}>
            {isImageFile(data.imagePath) ? (
              <img src={`${API_BASE_URL}${data.imagePath}`} alt={data.fullName} style={styles.photo} />
            ) : (
              <span style={styles.initial}>{data.fullName?.charAt(0)}</span>
            )}

            <h2 style={styles.name}>{data.fullName}</h2>
            <p style={styles.sub}>{data.designation}</p>
            <p style={styles.sub}>{data.company}</p>

            <div style={styles.rows}>
              <div style={styles.row}>
                <span style={styles.label}>Event</span>
                <span style={styles.value}>{EVENT_NAMES[data.eventName] || data.eventName}</span>
              </div>
              <div style={styles.row}>
                <span style={styles.label}>Ticket ID</span>
                <span style={styles.value}>{data.ticketId || "-"}</span>
              </div>
              <div style={styles.row}>
                <span style={styles.label}>Order ID</span>
                <span style={styles.value}>{data.orderId || "-"}</span>
              </div>
              <div style={styles.row}>
                <span style={styles.label}>Payment</span>
                <span style={{ ...styles.value, color: data.isPaid ? "#16a34a" : "#dc2626" }}>
                  {data.isPaid ? "Paid ✓" : "Unpaid"}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}